import { Routes } from "@/app/routes.ts";
import { WorkleapLogo } from "@/components/ui/illustrations/WorkleapLogo.tsx";
import { Link } from "@hopper-ui/components";

export const ErrorHeader = () => {
    return (
        <Link
            href={Routes.Home()}
            top={{ base: "1rem", sm: "2rem" }}
            left={{ base: "1rem", sm: "2rem" }}
            position="absolute"
            UNSAFE_width={{ base: "8.75rem", sm: "9.375rem" }}
        >
            <WorkleapLogo />
        </Link>
    );
};
